
import Vue from 'vue';

// We want a few modes
// a 'sm', 'lg' and 'xl' which will be the various container widths
// without any settings, determine based on the screen size (use bootstrap container size)
// an auto size, which will be as large as the content, but not larger than the screen.

// maybe something like shrink true/false in addition to a size='sm|lg|xl|auto'

export default Vue.extend({
	props: {
		close: {default: true},
		closeEnabled: {default: true},
		closeMessage: {default: 'Close'},
		closeClass: {default: 'btn-default'},

		confirm: {default: true},
		confirmEnabled: {default: true},
		confirmMessage: {default: 'OK'},
		confirmClass: {default: 'btn-primary'},

		title: {default: 'Title'},
		size: { type: String as () => 'xs' | 'sm' | 'md' | 'lg' | 'auto' | 'fullscreen' | undefined },
		xs: Boolean,
		sm: Boolean,
		md: Boolean,
		lg: Boolean,
		auto: Boolean,
		fullscreen: Boolean,
	},
	computed: {
		classes(): Record<string, boolean> {
			const c: any = {
				'modal': true,
				'fade': true,
				'in': true,
				'xs': !this.size && this.xs,
				'sm': !this.size && this.sm,
				'md': !this.size && this.md,
				'lg': !this.size && this.lg,
				'auto': !this.size && this.auto,
				'fullscreen': !this.size && this.fullscreen,
			}
			if (this.size) c[this.size] = true;

			return c;
		}
	},
	created() {
		document.body.classList.add('modal-open');
		document.body.setAttribute('data-modal-count', (parseInt(document.body.getAttribute('data-modal-count') || '0') + 1).toString());
	},
	beforeDestroy() {
		document.body.setAttribute('data-modal-count', (parseInt(document.body.getAttribute('data-modal-count') || '0') - 1).toString());
		if (!document.body.hasAttribute('data-modal-count') || document.body.getAttribute('data-modal-count') === '0')
			document.body.classList.remove('modal-open');
	}
})
